import { useSession, useSettings } from '../api/hooks';

/** Why AI features are unavailable to the person reading. */
export type AIOffReason = 'account' | 'server' | 'setup';

/** What to do about it, worded for who's reading: on a shared server a member can't edit .env. */
export const AI_OFF_FIX: Record<AIOffReason, string> = {
  account: "It's turned off for your account. Ask the person who runs this server.",
  server: "It's turned off on this server.",
  setup: 'Add GEMINI_API_KEY to .env and restart the server.',
};

/** account: a 0 daily allowance; server: a shared server without AI; setup: your own copy, without a key yet. */
export function useAIOffReason(): AIOffReason {
  const ai = useSettings().data?.ai;
  const signInOn = useSession().data?.required ?? false;
  return ai?.offReason === 'account' ? 'account' : signInOn ? 'server' : 'setup';
}
